<div class='container-fluid'>
  <router-outlet></router-outlet>

  <!--<div class='row'>
    <div class='col-sm-3'>
      <app-nav-menu></app-nav-menu>
    </div>
    <div class='col-sm-9 body-content'>
    </div>
  </div>-->
</div>
